import script from "./channelAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./channelAdd.vue?vue&type=script&lang=ts&setup=true"

import "./channelAdd.vue?vue&type=style&index=0&id=81f1d44c&lang=less&scope=true"

const __exports__ = script;

export default __exports__